import React, { useState } from "react";

export default function ApproveSellRequestModal({
  isOpen,
  onClose,
  onContinue,
  individualBondData,
}) {
  console.log("individualBondData", individualBondData);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-md shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold text-[#035C98] mb-2">Purchase Order</h2>
        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to confirm the purchase order for ‘
          {individualBondData?.original?.bondName}’
        </p>

        <div className="flex mt-6 justify-between">
          <button
            onClick={() => onClose(false)}
            className="px-6 py-2 rounded-md border border-gray-300 text-[#000000] hover:bg-gray-100"
          >
            Back
          </button>

          <button
            onClick={() => onContinue("approve")}
            className="px-6 py-2 rounded-md bg-[#FFB819] text-[#101010]"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
